// Private font preview page — visit /font-preview to compare candidates.
// Each block shows the same hero copy in a different font so we can pick.

const FONTS = [
  {
    key: "cormorant",
    label: "Cormorant Garamond (current — classic + elegant)",
    stack: '"Cormorant Garamond", Georgia, serif',
    note: "The current site font. Warm, romantic, classical.",
  },
  {
    key: "playfair",
    label: "Playfair Display (editorial + dramatic)",
    stack: '"Playfair Display", Georgia, serif',
    note: "Editorial magazine feel — dramatic contrast, timeless, confident.",
  },
  {
    key: "libre-caslon",
    label: "Libre Caslon Text (heritage American publishing)",
    stack: '"Libre Caslon Text", Georgia, serif',
    note: "Feels like the New York Times or a hardcover novel. Rooted, literary.",
  },
  {
    key: "crimson",
    label: "Crimson Pro (literary + warm, book serif)",
    stack: '"Crimson Pro", Georgia, serif',
    note: "Reads like a Wendell Berry paperback — quiet strength, warm.",
  },
  {
    key: "dm-serif",
    label: "DM Serif Display (bold editorial)",
    stack: '"DM Serif Display", Georgia, serif',
    note: "Big, confident, magazine-cover serif. Modern but rooted.",
  },
  {
    key: "spectral",
    label: "Spectral (contemporary, humanist serif)",
    stack: '"Spectral", Georgia, serif',
    note: "Modern, clean, warm — reads like a well-designed poetry chapbook.",
  },
];

export default function FontPreview() {
  return (
    <div className="min-h-screen bg-cream py-24 lg:py-32" data-testid="font-preview-page">
      <div className="container-narrow mb-16">
        <p className="overline mb-4">Font Preview</p>
        <h1 className="font-serif text-4xl lg:text-5xl text-moss font-light leading-tight">
          Pick the voice of Iron Talon Farm.
        </h1>
        <p className="mt-6 text-coal/70 text-base leading-[1.85]">
          Each block below shows the same hero copy set in a different font.
          Whichever feels most "you", tell me the label and I'll roll it out sitewide.
        </p>
      </div>

      <div className="container-x space-y-14">
        {FONTS.map((f) => (
          <div
            key={f.key}
            className="border-t border-moss/15 pt-10"
            data-testid={`font-block-${f.key}`}
          >
            <p className="overline mb-3">{f.label}</p>
            <p className="text-xs text-coal/50 mb-6 italic">{f.note}</p>

            <div style={{ fontFamily: f.stack }}>
              <p className="text-[11px] uppercase tracking-[0.32em] text-clay mb-4">
                Kempton, Pennsylvania · 50 acres · Est. mid 1800s
              </p>
              <h2 className="text-5xl lg:text-7xl text-moss font-light leading-[1.02] tracking-tight max-w-4xl">
                A sanctuary where <em className="not-italic text-clay">iron sharpens iron.</em>
              </h2>
              <p className="mt-6 text-2xl lg:text-3xl text-moss font-light italic">
                Six historic cottages. One unhurried stay.
              </p>
              <p className="mt-6 max-w-2xl text-lg text-coal/70 leading-[1.85]" style={{ fontFamily: '"Manrope", sans-serif' }}>
                <span className="text-clay text-[11px] uppercase tracking-widest">Body text stays Manrope →</span>
                {" "}Spread across 50 acres, each cottage has its own personality — some off-grid,
                some by the creek, some perched on a hilltop.
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
